<template>
    <div id="InfoRequest" class="inforequest inner">
        <div v-if="!isSuccess" class="request">
            <div v-if="!isLoading" class="formimage">
                <div class="form" data-request>
                    <fieldset :disabled="isLoadingForm">
                        <h3 class="maintitle s36">{{ titleForm }}</h3>
                        <div class="item">
                            <label for="NameSurname">{{ localizer.get("LandingPage.InfoRequest.NameSurname") }}</label>
                            <input type="text" id="NameSurname" v-model.lazy="formData.nameSurname" :class="[{ 'input-validation-error': isValidationError('NameSurname') }, 'input w300']">
                        </div>
                        <div class="group">
                            <div class="item">
                                <label for="Phone">{{ localizer.get("LandingPage.InfoRequest.PhoneEmail") }}</label>
                                <input type="tel" :aria-label="localizer.get('LandingPage.InfoRequest.Phone')" id="Phone" :placeholder="localizer.get('LandingPage.InfoRequest.PhonePlaceholder')" v-model.lazy="formData.phone" :class="[{ 'input-validation-error': isValidationError('Phone') }, 'input w300']">
                            </div>
                            <div class="item">
                                <input type="email" :aria-label="localizer.get('LandingPage.InfoRequest.Email')" id="Email" :placeholder="localizer.get('LandingPage.InfoRequest.EmailPlaceholder')" v-model.lazy="formData.email" :class="[{ 'input-validation-error': isValidationError('Email') }, 'input w300']">
                            </div>
                        </div>
                        <div class="item">
                            <label for="Zone">{{ localizer.get("LandingPage.InfoRequest.Zone") }}</label>
                            <template v-if="language === 'it'">
                                <select id="Zone" v-model.lazy="formData.zone" :class="[{ 'input-validation-error': isValidationError('Zone') }, 'input w300']">
                                    <option :value="null">{{ localizer.get("LandingPage.InfoRequest.Select") }}</option>
                                    <option v-for="(item, index) in zones" :value="item.value" :key="index">{{ item.title }}</option>
                                </select>
                            </template>
                            <template v-else>
                                <input type="text" :aria-label="localizer.get('LandingPage.InfoRequest.Zone')" id="Zone" v-model.lazy="formData.zone" :class="[{ 'input-validation-error': isValidationError('Zone') }, 'input w300']">
                            </template>
                        </div>
                    </fieldset>
                    <fieldset v-if="isCompany" :disabled="isLoadingForm">
                        <div class="item">
                            <label for="Company">{{ localizer.get("LandingPage.InfoRequest.Company") }}</label>
                            <input type="text" :aria-label="localizer.get('LandingPage.InfoRequest.Company')" id="Company" v-model.lazy="formData.company" :class="[{ 'input-validation-error': isValidationError('Company') }, 'input w300']">
                        </div>
                        <div class="item">
                            <label for="Profession">{{ localizer.get("LandingPage.InfoRequest.Profession") }}</label>
                            <input type="text" :aria-label="localizer.get('LandingPage.InfoRequest.Profession')" id="Profession" v-model.lazy="formData.profession" :class="[{ 'input-validation-error': isValidationError('Profession') }, 'input w300']">
                        </div>
                    </fieldset>
                    <fieldset v-if="isAddress" :disabled="isLoadingForm">
                        <div class="checkbox">
                            <input type="checkbox" id="IsAddress" v-model="formData.isAddress">
                            <label for="IsAddress">{{ addressLabel }}</label>
                        </div>
                    </fieldset>
                    <fieldset v-if="formData.isAddress" :disabled="isLoadingForm">
                        <div class="group">
                            <div class="item">
                                <label for="Address">{{ localizer.get("LandingPage.InfoRequest.Address") }}</label>
                                <input type="text" :aria-label="localizer.get('LandingPage.InfoRequest.Address')" :placeholder="localizer.get('LandingPage.InfoRequest.Address')" id="Address" v-model.lazy="formData.address" :class="[{ 'input-validation-error': isValidationError('Address') }, 'input w300']">
                            </div>
                            <div class="item">
                                <input type="text" :aria-label="localizer.get('LandingPage.InfoRequest.PostCode')" :placeholder="localizer.get('LandingPage.InfoRequest.PostCode')" id="PostCode" v-model.lazy="formData.postCode" :class="[{ 'input-validation-error': isValidationError('PostCode') }, 'input w160']">
                            </div>
                        </div>
                        <div class="item">
                            <label for="Location">{{ localizer.get("LandingPage.InfoRequest.Location") }}</label>
                            <input type="text" :aria-label="localizer.get('LandingPage.InfoRequest.Location')" id="Location" v-model.lazy="formData.location" :class="[{ 'input-validation-error': isValidationError('Location') }, 'input w300']">
                        </div>
                    </fieldset>
                    <fieldset :disabled="isLoadingForm">
                        <div class="desc small" v-html="localizer.get('LandingPage.InfoRequest.PrivacyPolicy', routes.UrlPrivacyPolicy)"></div>
                        <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                            <ul>
                                <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                            </ul>
                        </div>
                        <div class="cta">
                            <button @click="submitForm()" :class="[{ 'loading': isLoadingForm }, 'button']">
                                <template v-if="!isLoadingForm">{{ localizer.get("LandingPage.InfoRequest.SendRequest") }}</template>
                            </button>
                        </div>
                    </fieldset>
                    <div class="desc small grecaptcha-terms" v-html="localizer.get('LandingPage.Support.Captcha_Terms')"></div>
                </div>
                <img src="/images/support.webp" width="620" height="772" :alt="addressLabel" class="support-image">
            </div>
        </div>
        <div v-else class="confirm">
            <div class="maintitle s60">{{ localizer.get("LandingPage.InfoRequest.FormSuccessTitle") }}</div>
            <div class="cta s16 secondary"><a :href="routes.Home" class="button">{{ localizer.get("LandingPage.InfoRequest.ContinueBrowsing") }}</a></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

const props = defineProps<{
    recaptchaSiteKey: string;
    landingPageSlug: string;
    landingName: string;
    isCompany: boolean;
    isAddress: boolean;
    addressLabel: string;
    titleForm: string;
    language: string;
}>();

const localizer = Localizer;
const routes = (window as any).App.routes;
const titleForm = ref(localizer.get("LandingPage.InfoRequest.Title"));

const isLoading = ref(true);
const isLoadingForm = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({ zone: null, isCompany: false, isAddress: false });
const zones = ref<any[]>([]);
const validationErrors = ref<any[]>([]);

onBeforeMount(async () => {
    await getData();

    titleForm.value = props.titleForm ? props.titleForm : titleForm.value;
});

async function getData() {
    const response = (await Axios.post(routes.LandingPage_LandingPage_GetSubscribeData)).data;
    zones.value = response.zones;
    isLoading.value = false;
}

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];
    isLoadingForm.value = true;
    formData.value.landingPageSlug = props.landingPageSlug;
    formData.value.isCompany = props.isCompany;

    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: "Submit" });
        try {
            await Axios.post(routes.LandingPage_LandingPage_Submit, formData.value, { headers: { RecaptchaVerificationToken: token } });
            isSuccess.value = true;
            GTagHelper.sendEvent("form_submit", "landing_info_request", props.landingName);
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }

        isLoadingForm.value = false;
    });
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}
</script>